export const removeEmptyMembersFromArray = (initialArray) => {
    const finalArray = [];
    if (Array.isArray(initialArray) !== true){
        return initialArray
    }

    if (initialArray.length === 0){
        return initialArray;
    }

    for(let item of initialArray){
        if(item !== null && item !== 'undefined'){
            finalArray.push(item);
        }
    }

    return finalArray;
}

export const makeArrayUnique = (initialArray) => {
    if (Array.isArray(initialArray) !== true){
        return initialArray
    }

    if (initialArray.length < 2){
        return initialArray;
    }

    const uniqueArray = [...new Set(initialArray)];

    return uniqueArray;
}